import { Mode, WebhookConfig } from '../types';

const WEBHOOK_URLS: WebhookConfig = {
  test: 'https://n8n.anouar.ca/webhook-test/c088f70e-a015-41fd-a948-f16504cc09bb',
  prod: 'https://n8n.anouar.ca/webhook/c088f70e-a015-41fd-a948-f16504cc09bb'
};

export const sendToWebhook = async (videoId: string, mode: Mode): Promise<Response> => {
  const url = `${WEBHOOK_URLS[mode]}?videoId=${encodeURIComponent(videoId)}`;
  const username = import.meta.env.VITE_WEBHOOK_USERNAME;
  const password = import.meta.env.VITE_WEBHOOK_PASSWORD;
  
  if (!username || !password) {
    throw new Error('Webhook credentials not configured');
  }

  const authHeader = 'Basic ' + btoa(`${username}:${password}`);
  
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader
      }
    });
    
    return response;
  } catch (error) {
    console.error('Error sending to webhook:', error);
    throw error;
  }
};

export const getWebhookConfig = (): WebhookConfig => {
  return WEBHOOK_URLS;
};